import React from 'react';
import '../assets/styles/MunicipioLayout.scss';
import CuentaPublicaBody from '../components/municipalidad/CuentaPublicaBody';

const CuentaPublica = () => (
  <div className='MainMunicipio'>
    <CuentaPublicaBody />
  </div>
);
export default CuentaPublica;
